const author = (churn, short) => {
  if (!churn) return ''
  if (churn?.automatic) {
    if (short) return 'Sistema'
    return 'Automático pelo sistema'
  }

  return churn?.responsible?.name || ''
}

export default author
